import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import FAQSection from './components/FAQSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <FeaturesSection />
        <CardsSection />
        <ContactSection />
        <UpdatesSection />
        <AboutSection />
        <RankingSection />
        <AppSection />
        <CarouselSection />
        <CommentsSection />
        <FAQSection />
        <TopicsSection />
        <IndexSection />
      </main>
      <Footer />
    </div>
  );
}